import React from 'react';
import { motion } from 'framer-motion';
import SEO from './SEO';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

export default function LegalPage() {
    const { t } = useLanguage();
    const { theme } = useTheme();

    const sections = [
        {
            id: 'terms',
            title: t('legal.termsTitle'),
            content: t('legal.termsText')
        },
        {
            id: 'privacy',
            title: t('legal.privacyTitle'),
            content: t('legal.privacyText')
        },
        {
            id: 'shipping',
            title: t('legal.shippingTitle'),
            content: t('legal.shippingText')
        }
    ];

    return (
        <div className={`min-h-screen pt-24 pb-12 ${theme === 'dark' ? 'bg-dark-bg' : 'bg-off-white'}`}>
            <SEO
                title={t('legal.title')}
                description={t('legal.termsTitle')}
                canonicalPath="/legal"
            />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-16"
                >
                    <h1 className={`text-5xl md:text-7xl font-bold mb-4 tracking-tighter ${theme === 'dark' ? 'text-white' : 'text-charcoal'}`}>
                        {t('legal.title')}
                    </h1>
                </motion.div>

                <div className="space-y-16">
                    {sections.map((section, index) => (
                        <motion.div
                            key={section.id}
                            id={section.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                            className={`p-8 rounded-lg ${theme === 'dark' ? 'bg-charcoal/50' : 'bg-white'} shadow-lg`}
                        >
                            <h2 className={`text-2xl md:text-3xl font-bold mb-6 ${theme === 'dark' ? 'text-white' : 'text-charcoal'}`}>
                                {section.title}
                            </h2>
                            <p className={`text-lg leading-relaxed ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'} font-light`}>
                                {section.content}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
}
